<template>
  <div
    :class="['relative', extraClass, multiple && 'is-multiple-choice']"
  >
    <label
      v-if="label"
      class="text-xs text-gray-600 mb-auto"
    >
      {{ label }}
    </label>

    <v-select
      :placeholder="placeholder"
      :options="options"
      :components="{OpenIndicator}"
      :value="value"
      :class="[error.length > 0 ? 'error' : '', 'w-full mt-auto']"
      :reduce="reduce"
      :multiple="multiple"
      @input="onInput"
    />
    <span v-if="error" class="px-2 py-px text-xs leading-none text-white input-error bg-lh_error">
      {{ error }}
    </span>
  </div>
</template>

<script>
import Select from '~brand-components/base/select/select'

export default Select.extend()
</script>

<style lang="scss">
.v-select {
  @apply text-lg;

  .vs__dropdown-toggle {
    @apply text-gray-600 min-h-10 p-0 border-0 border-b-2 border-gray-600 rounded-none;
  }

  .vs__selected-options {
    @apply p-0;
  }

  .vs__selected {
    @apply h-10 border-0 rounded-none p-0 m-0;
  }

  .vs__search {
    @apply m-0 p-0;
  }

  .vs__actions {
    @apply p-0 pr-2;
  }

  .vs__open-indicator {
    display: block;
    width: 13px;
    height: 8px;
    background: url('~images/lufthansa/icons/arrow-down.svg') 0 0 / 13px 8px no-repeat;
  }

  .vs__clear {
    @apply hidden;
  }

  .vs__dropdown-menu {
    top: calc(100% + 10px);

    @apply shadow-6 px-0 border-0 rounded-none;
  }

  .vs__dropdown-option {
    @apply leading-none p-3;
  }

  .vs__dropdown-option--highlight {
    @apply bg-navy-700 text-white;
  }

  .vs__dropdown-option--selected {
    @apply bg-primary text-white;
  }

  &.vs--open {
    .vs__dropdown-toggle {
      @apply shadow-1 pl-3;
    }

    .vs__selected {
      @apply top-0 left-0;
    }
  }

  &.error {
    .vs__dropdown-toggle {
      @apply border-lh_error;
    }
  }
}

.is-multiple-choice {
  .v-select {
    .vs__selected {
      @apply h-8 p-2 mr-2 my-1;
    }
  }

}
</style>
